import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { dialogClosed, dialogOpened, type ExtractorData } from 'Core/actions/dialog';

const initStates: { extractorData: ExtractorData; opened: string[] } = {
  extractorData: null,
  opened: [],
};

export default combineReducers({
  opened: createReducer(initStates.opened, (builder) =>
    builder
      .addCase(dialogOpened, (state, { payload }) =>
        state.includes(payload) || payload === 'VehicleWidgetDialog' ? state : [...state, payload],
      )
      .addCase(dialogClosed, (state, { payload }) =>
        payload === 'VehicleWidgetDialog' ? state : state.slice(0, -1),
      ),
  ),
  extractorData: createReducer(initStates.extractorData, (builder) =>
    builder
      .addCase(dialogOpened, (state, { meta: { extractorData } }) => extractorData ?? state)
      .addDefaultCase(() => initStates.extractorData),
  ),
});
